import API from 'services/TAPS_API/index';
import { moment } from 'utils';

export default function getOverpaymentsMessage(notificationId) {
  return API.request({
    method: 'GET',
    url: `/overpayments/data`,
    params: {
      notificationId,
    },
    mapper: function (data) {
      //todo: check date format
      return {
        date: data.docDate ? moment.fromFullDatetime(data.docDate) : null,
        documentNumber: data.docNum || null,
        taxAuthority: {
          code: data.taxAuthorityCode,
          name: data.taxAuthorityName,
        },
      };
    },
  });
}
